import { EMAIL_REGEX } from '@chilipiper/utils'

type OnEmailCaptured = (params: {
  email: string
  formId: string
  formName: string
  emailFieldName: string
  emailFieldId: string
}) => void

const scoreInput = (input: HTMLInputElement): number => {
  let score = 0
  if (input.type.toLowerCase() === 'email') score += 3
  if (/email/i.test(input.name) || /email/i.test(input.id)) score += 2
  if (EMAIL_REGEX.test(input.value)) score += 1
  return score
}

const findBestEmailInput = (form: HTMLFormElement): HTMLInputElement | null => {
  let best: HTMLInputElement | null = null
  let bestScore = 0
  for (const input of form.querySelectorAll<HTMLInputElement>('input')) {
    if (!EMAIL_REGEX.test(input.value)) continue
    const score = scoreInput(input)
    if (score > bestScore) {
      best = input
      bestScore = score
    }
  }
  return best
}

export const trackEmailFromForm = (
  form: HTMLFormElement,
  onEmailCaptured: OnEmailCaptured
): void => {
  const input = findBestEmailInput(form)
  if (!input) return
  onEmailCaptured({
    email: input.value,
    formId: form.id,
    formName: form.name,
    emailFieldName: input.name,
    emailFieldId: input.id,
  })
}
